// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5d5a6c70] .ant-form-inline .ant-form-item {\n  width: calc(50% - 16px);\n}\n", ""]);
// Exports
module.exports = exports;
